import { Box, Flex, Group, Stack, Text, Title } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { NoContentPlaceholder } from '@/core/components';

import { SortDirection } from '@feature/utils';

import { Pagination } from '../../Pagination/Pagination';

interface PaginationProps {
  currentPage: number;
  onChange: (value: number) => void;

  pageSize: number;
  totalElements: number | undefined;
  totalPages: number | null;
}

interface BrowseProps<T> {
  actions: ReactNode;
  filters?: ReactNode;
  title: string;
  subtitle?: string;
  pagination: PaginationProps;

  data: T[];
  renderItem: (item: T) => ReactNode;

  sortDirection: SortDirection;
  sortedBy: string;
  toggleSortDirection: () => void;
}

export function Browse<T>(props: BrowseProps<T>) {
  const {
    actions,
    title,
    subtitle,
    pagination,
    data,
    renderItem,
    filters,
    sortedBy,
    sortDirection,
    toggleSortDirection,
  } = props;
  const { t } = useTranslation();
  return (
    <Stack>
      <Flex justify="space-between">
        <Title size="1.4rem">{title}</Title>
        {actions}
      </Flex>
      {subtitle && <Title order={2}>{subtitle}</Title>}
      <Text
        size="xs"
        c="dimmed"
        fw="500"
        fs="italic"
      >
        Se afișează {data?.length ?? '-'} dintr-un total de {pagination?.totalElements ?? '-'}
      </Text>
      {filters}
      {data != null && data.length > 0 ? (
        <Box>
          <Group gap="2px">
            <Text
              size="xs"
              c="dimmed"
              fs="italic"
            >
              {sortedBy}
            </Text>
            <Text
              style={{ cursor: 'pointer' }}
              onClick={toggleSortDirection}
              size="xs"
              fw="500"
              fs="italic"
            >
              {sortDirection}
            </Text>
          </Group>
          <Stack>{data.map(renderItem)}</Stack>
          <Pagination {...pagination} />
        </Box>
      ) : (
        <NoContentPlaceholder title={t('noContent.title')} />
      )}
    </Stack>
  );
}
